// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { useSafeClient } from '@safecoin/dapp-kit';
import { useQuery } from '@tanstack/react-query';

// This should align with whatever names we want to be able to resolve.
const SAFE_NS_DOMAINS = ['.safe'];
export function isSafeNSName(name: string) {
	return SAFE_NS_DOMAINS.some((domain) => name.endsWith(domain));
}

export function useSafeNSEnabled() {
	return true;
}

export function useResolveSafeNSAddress(name?: string | null, enabled?: boolean) {
	const client = useSafeClient();
	const enabledSafeNs = useSafeNSEnabled();

	return useQuery({
		queryKey: ['resolve-safens-address', name],
		queryFn: async () => {
			return await client.resolveNameServiceAddress({
				name: name!,
			});
		},
		enabled: !!name && enabled && enabledSafeNs,
		refetchOnWindowFocus: false,
		retry: false,
	});
}

export function useResolveSafeNSName(address?: string | null) {
	const client = useSafeClient();
	const enabled = useSafeNSEnabled();

	return useQuery({
		queryKey: ['resolve-safens-name', address],
		queryFn: async () => {
			// NOTE: We only fetch 1 here because it's the default name.
			const { data } = await client.resolveNameServiceNames({
				address: address!,
				limit: 1,
			});

			return data[0] || null;
		},
		enabled: !!address && enabled,
		refetchOnWindowFocus: false,
		retry: false,
	});
}
